var React = require('react');
var Advert = require('../Advert.jsx');
var EditorialModule = require('./EditorialModule.jsx');

var AdModule = React.createClass({
    componentDidMount: function() {
        if(!this.inited){
            this.initAds();
            this.inited = true;
        }
    },
    componentDidUpdate: function(prevProps, prevState) {
        
    },
    inited : false,
    initAds: function(){
        try{
            var ads = jQuery('.col-c .react-ad');
            for(var i=0, len = ads.length; i < len; i++){
                admgr.initSlot(ads[i], espn.ads.config);
            }
        }catch(e){}
    },
    render: function(){
        return (
            <article className="ad-300">
                <div className="ad-center">
                    <Advert id='rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                </div>
            </article>
        );
    }
});

var RHS = React.createClass({
    render: function(){
            
        var modules = this.props.modules || [];
        var modulesMarkup = [];
        
        modules.map(function(module, i){
            if(module.type === 'editorial'){
                modulesMarkup.push(
                    <EditorialModule key={module.moduleType + '.' + i} title={module.moduleTitle} links={module.feed} />
                );
            }else if(module.type === 'adincontent'){
                modulesMarkup.push(
                    <AdModule key='rhs.mpu' />
                );
            }
        });
        
        return (
            <section className="col-c chk-height">
                {modulesMarkup}
            </section>
        );
    }
});

module.exports = RHS;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/rhs/Index.jsx
 **/